import { usePersonasList } from '@/api/queries'

interface Props { onOpen: (role: string) => void }

export function PersonasList({ onOpen }: Props) {
  const q = usePersonasList()
  if (q.isLoading) return <div className="page"><p>Loading…</p></div>
  if (q.isError) return <div className="page"><p style={{ color: 'var(--err)' }}>Failed to load personas: {(q.error as Error).message}</p></div>
  const items = q.data?.items ?? []
  return (
    <div className="page">
      <div className="page-head"><h1>Personas</h1><p>{items.length} loaded</p></div>
      <table className="tbl">
        <thead><tr><th>role</th><th>status</th><th>last modified by</th><th></th></tr></thead>
        <tbody>
          {items.map((p) => (
            <tr key={p.role}>
              <td className="mono">{p.role}</td>
              <td>{p.status}</td>
              <td className="mono" style={{ fontSize: 'var(--fs-200)' }}>{p.lastModifiedBy}</td>
              <td><button className="btn" onClick={() => onOpen(p.role)}>Open</button></td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={4}><div className="empty">No personas yet — drafts will appear here.</div></td></tr>}
        </tbody>
      </table>
    </div>
  )
}
